import * as React from "react";

import { InitialStateMinimumRequirements_Recaptcha_ForAnyParticularConfigurationIsland } from "../../../Common";

export interface ReactGiftCardInitialStateInterface {
  form_submit_action: string;
  product_id: string;
  formkey: string;
  checkout_url: string;
  amounts: string[];
  add_url: string;

  giftcard_balance_recaptcha: InitialStateMinimumRequirements_Recaptcha_ForAnyParticularConfigurationIsland;

  store_code: any;
}

export interface ReactGiftCardInitialStateConsumerInterface {
  initialState: ReactGiftCardInitialStateInterface;
}

const defaultValue = {
  initialState: {} as ReactGiftCardInitialStateInterface,
};

export const ReactGiftCardInitialStateContext = React.createContext(
  (defaultValue as unknown) as ReactGiftCardInitialStateConsumerInterface
);

interface ReactGiftCardInitialStateProviderProps {
  mountElement: Element | null;
}

export const ReactGiftCardInitialStateProvider: React.FunctionComponent<
  ReactGiftCardInitialStateProviderProps
> = (props) => {
  const initialState = React.useMemo(() => {
    const mountElement = (props.mountElement || {}) as HTMLElement;

    const initialStateJsonString =
      mountElement?.dataset.reactGiftcard__initialstate || "{ amounts: [] }";

    const initialState = JSON.parse(
      initialStateJsonString
    ) as ReactGiftCardInitialStateInterface;
    return initialState;
  }, [props.mountElement]);
  return (
    <ReactGiftCardInitialStateContext.Provider value={{ initialState }}>
      {props.children}
    </ReactGiftCardInitialStateContext.Provider>
  );
};

export const useReactGiftCardInitialState = (): ReactGiftCardInitialStateConsumerInterface =>
  React.useContext(ReactGiftCardInitialStateContext);
